import React, { ReactElement } from "react";
import {
  ComponentStyleProps,
  componentStylePropsOf,
} from "../../../../lib/styles/props/component-style-props";
import { BsCircleFill } from "react-icons/bs";
import { Box, HStack, Text, useMultiStyleConfig } from "@chakra-ui/react";
import { IconContext } from "react-icons";

export type FormRequiredLabelProps = {
  size?: "md" | "lg";
  icon?: ReactElement;
  label?: string;
} & ComponentStyleProps;

export const FormRequiredLabel = ({
  icon = <BsCircleFill />,
  label = "必須",
  sx,
  ...rest
}: FormRequiredLabelProps) => {
  const styles = useMultiStyleConfig("FormRequiredLabelStyles");
  return (
    <HStack spacing="3px" sx={{ ...styles, ...sx }} {...rest}>
      <Box sx={styles.icon}>
        <IconContext.Provider value={{ size: "5px" }}>
          <Box>{icon}</Box>
        </IconContext.Provider>
      </Box>
      <Text sx={styles.label}>{label}</Text>
    </HStack>
  );
};

export const FormRequiredLabelStyles = {
  parts: ["icon", "label"],
  baseStyle: {
    icon: {
      display: "flex",
      color: "red.500",
      justifyContent: "center",
      alignItems: "center",
    },
    label: {
      color: "red.500",
      fontSize: "xs",
    },
  },
};
